import useTableData from "../../../../state/table/UseTableData";

const useExpandAllIcon = () => {
  const { tableState, onUpdateExpandedIds } = useTableData();

  const onIconClicked = (e) => {
    e?.preventDefault();
    e?.stopPropagation();

    const newExpandedIds = tableState.expandedIds.length === tableState.sortedData.length
      ? []
      : tableState.sortedData.map(row => row[`${tableState.rowIdKey}`]);

    onUpdateExpandedIds(newExpandedIds);
  };

  return {
    tableHasData: tableState.sortedData.length > 0,
    areAllExpanded: tableState.expandedIds.length === tableState.sortedData.length,
    onIconClicked
  };
};

export default useExpandAllIcon;